'use client';

import { ReactNode, useEffect, useRef } from 'react';

export function AutoScrollWrapper({
  className,
  to,
  children,
}: {
  className?: string;
  to: 'center' | 'start' | 'end';
  children: ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current?.scrollIntoView({
      behavior: 'smooth',
      block: to,
    });
  }, [ref]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
